import { generatePath } from 'react-router-dom';
import { ResponseError } from '@backstage/errors';
import { DEFAULT_NAMESPACE } from '@backstage/catalog-model';
import { createApiRef, createPlugin, createApiFactory, fetchApiRef, discoveryApiRef, configApiRef, createComponentExtension } from '@backstage/core-plugin-api';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class BadgesClient {
  constructor(options) {
    __publicField(this, "discoveryApi");
    __publicField(this, "fetchApi");
    __publicField(this, "configApi");
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
    this.configApi = options.configApi;
  }
  static fromConfig(options) {
    return new BadgesClient(options);
  }
  async getEntityBadgeSpecs(entity) {
    const obfuscate = this.configApi.getOptionalBoolean("app.badges.obfuscate");
    if (obfuscate) {
      const entityUuidUrl = await this.getEntityUuidUrl(entity);
      const entityUuid = await this.getEntityUuid(entityUuidUrl).then((data) => {
        return data.uuid;
      });
      const entityUuidBadgeSpecsUrl = await this.getEntityUuidBadgeSpecsUrl(
        entityUuid
      );
      const response2 = await this.fetchApi.fetch(entityUuidBadgeSpecsUrl);
      if (!response2.ok) {
        throw await ResponseError.fromResponse(response2);
      }
      return await response2.json();
    }
    const entityBadgeSpecsUrl = await this.getEntityBadgeSpecsUrl(entity);
    const response = await this.fetchApi.fetch(entityBadgeSpecsUrl);
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return await response.json();
  }
  async getEntityUuidUrl(entity) {
    const routeParams = this.getEntityRouteParams(entity);
    const path = generatePath(`:namespace/:kind/:name`, routeParams);
    const baseUrl = await this.discoveryApi.getBaseUrl("badges");
    const obfuscatedEntityUrl = `${baseUrl}/entity/${path}/obfuscated`;
    return obfuscatedEntityUrl;
  }
  async getEntityUuid(entityUuidUrl) {
    const responseEntityUuid = await this.fetchApi.fetch(entityUuidUrl);
    if (!responseEntityUuid.ok) {
      throw await ResponseError.fromResponse(responseEntityUuid);
    }
    return await responseEntityUuid.json();
  }
  async getEntityUuidBadgeSpecsUrl(entityUuid) {
    const baseUrl = await this.discoveryApi.getBaseUrl("badges");
    return `${baseUrl}/entity/${entityUuid}/badge-specs`;
  }
  async getEntityBadgeSpecsUrl(entity) {
    const routeParams = this.getEntityRouteParams(entity);
    const path = generatePath(`:namespace/:kind/:name`, routeParams);
    const baseUrl = await this.discoveryApi.getBaseUrl("badges");
    return `${baseUrl}/entity/${path}/badge-specs`;
  }
  // This function is used to generate the route parameters using the entity kind, namespace and name
  getEntityRouteParams(entity) {
    var _a, _b;
    return {
      kind: entity.kind.toLocaleLowerCase("en-US"),
      namespace: (_b = (_a = entity.metadata.namespace) == null ? void 0 : _a.toLocaleLowerCase("en-US")) != null ? _b : DEFAULT_NAMESPACE,
      name: entity.metadata.name
    };
  }
}

const badgesApiRef = createApiRef({
  id: "plugin.badges.client"
});

const badgesPlugin = createPlugin({
  id: "badges",
  apis: [
    createApiFactory({
      api: badgesApiRef,
      deps: {
        fetchApi: fetchApiRef,
        discoveryApi: discoveryApiRef,
        configApi: configApiRef
      },
      factory: ({ fetchApi, discoveryApi, configApi }) => new BadgesClient({
        fetchApi,
        discoveryApi,
        configApi
      })
    })
  ]
});
const EntityBadgesDialog = badgesPlugin.provide(
  createComponentExtension({
    name: "EntityBadgesDialog",
    component: {
      lazy: () => import('./EntityBadgesDialog-DwRwuts8.esm.js').then(
        (m) => m.EntityBadgesDialog
      )
    }
  })
);

export { EntityBadgesDialog as E, badgesPlugin as a, badgesApiRef as b };
//# sourceMappingURL=index-R_9uVcjC.esm.js.map
